module.exports = {"API_ROOT":"http://vipcardionet.com:7023","BACK_API_ROOT":"http://vipcardionet.com:7022","RECORD_API_ROOT":"http://www.heaguard.com:5093","ETC_ROOT":"http://www.heaguard.com:2000/#/","VERSION":"2.7.1"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 1